<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad" v-if="pOrigen!='cotizacion' && Propuesta.IdCotizacionServicio==0">
				<div class="row">
					<div class="col-lg-6">
						<label for="">Atención A *</label>
						<input type="text" v-model="Propuesta.AtencionA" placeholder="Atención A" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.AtencionA" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
					<div class="col-lg-6">
						<label for="">Correo Electrónico</label>
						<vue-tags-input v-model="Email" :tags="Para" 
						@tags-changed="newTags => Para = newTags" 
						placeholder="Para"/>
					</div>

					<div class="col-lg-4">
                        <label for="">Cliente *</label>
                        <treeselect
                            :options="ListaClientes"
                            placeholder="Cliente..."
                            v-model="Propuesta.IdCliente"
                            @input="GetListaPropiedades()"
							:disable-fuzzy-matching="true"
                        />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-4">
                        <label for="">Propiedad *</label>
                        <treeselect
                            :options="ListaPropiedades"
                            placeholder="Propiedad..."
                            v-model="Propuesta.IdClienteS"
							:disable-fuzzy-matching="true"
                        />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdClienteS" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-2">
                        <label for="">Numero *</label>
                        <input :disabled="Folio!=''" type="text" v-model="Propuesta.Numero" placeholder="Numero" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Numero" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-3">
                        <label for="">Tipo *</label>
                        <!-- <input type="text" v-model="Propuesta.Tipo" placeholder="Tipo" class="form-control"> -->
						<select @change="GetTipoSer" v-model="Propuesta.Tipo" class="form-control">
							<option value="">Seleccione un Tipo</option>
							<option value="1">Mantenimiento</option>
							<option value="2">Servicio</option>
							<option value="3">Proyecto</option>
						</select>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-3">
                        <label for="">Sub Tipo *</label>
                        <!-- <input type="text" v-model="Propuesta.Tipo" placeholder="Tipo" class="form-control"> -->
						<select v-model="Propuesta.IdTipoSer" class="form-control">
							<option value="">Seleccione un Sub Tipo</option>
							<option v-for="(item,index) in ListaTipoSer" :value="item.IdTipoSer" :key="index">{{item.Concepto}}</option>
						</select>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdTipoSer" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>

					<div class="col-lg-4">
                        <label for="">Nombre de la Propuesta *</label>
                        <input type="text" v-model="Propuesta.NombrePropuesta" placeholder="Nombre de la Propuesta" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NombrePropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-3">
                        <label for="">Valor *</label>
                        <vue-numeric
                            class="form-control "
                            currency="$"
                            separator=","
                            placeholder="$0"
                            :precision="0"
                            v-model="Propuesta.Valor"
                        ></vue-numeric>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Valor" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-2 pr-1">
                        <label for="">Fecha *</label>
                        <v-date-picker v-model="Propuesta.Fecha" :mode="typeCalendar"
                            :popover="{
                                placement: 'bottom',
                                visibility: 'click'
                            }"
                            :input-props="{
                                class: 'form-control cal-black',
                                style: 'cursor:pointer;'
                            }"
                            :locale="'es-MX'"
                        />
                    </div>
					<div class="col-lg-3">
                        <label for="">Vigencia *</label>
						<select v-model="Propuesta.Vigencia" class="form-control">
							<option value="">Seleccione una Opción</option>
							<option value="5">5 Días</option>
							<option value="10">10 Días</option>
							<option value="15">15 Días</option>
							<option value="20">20 Días</option>
							<option value="30">30 Días</option>
							<option value="60">60 Días</option>
						</select>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Vigencia" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>

					<div v-show="pOrigen!='cotizacion' || Propuesta.IdCotizacionServicio==0" class="col-lg-3 pr-4">
                        <label for="">Estatus *</label>
						<select :disabled="Propuesta.IdPropuesta==0 || pOrigen=='ventas' || (pOrigen!='cotizacion' && RolUsuario!='admin' && Propuesta.IdPropuesta>0) || PropuestaGanada" v-model="Propuesta.Estatus" class="form-control">
							<option value="">Selecciones un Estatus</option>
							<option v-show="BndActiva===true" value="Activa">Activa</option>
							<option v-show="BndGanada===true" value="Ganada">Ganada</option>
							<option value="Perdida">Perdida</option>
							<option value="Reemplazada">Reemplazada</option>
						</select>
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Estatus" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
					<div class="col-lg-6" v-show="Propuesta.IdCotizacionServicio==0">
						<label for="">Id Activo</label>
							<treeselect
							:options="Equipos"
							placeholder="Busque un Activo..."
							v-model="Propuesta.IdEquipo"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaEquipo"
						/>
					</div>

				</div>
                <div class="row">
					<div v-if="pOrigen!='cotizacion'" class="col-lg-6 mb-3">
						<label for="">Vendedor</label>
						<select @change="RellenaVendedor" class="form-control" v-model="Propuesta.IdVendedor" :disabled="Propuesta.IdCotizacionServicio!=''">
							<option value="0">- Vendedor -</option>
							<option v-for="(item,index) in ListaVendedor" :key="index" :value="item.IdVendedor">{{item.Nombre}}</option>
						</select>
					</div>
                    <div v-if="pOrigen!='cotizacion'" class="col-lg-6 mb-3">
                        <label for="">Archivo</label>
                        <div class="custom-file-input-image">
                            <input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                            <input type="text" v-model="Archivo" class="form-control">
                            <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                        </div>
                    </div>
					<div v-if="pOrigen=='cotizacion' || (Propuesta.IdCotizacionServicio!='' && Propuesta.IdCotizacionServicio!=0)" class="col-lg-12">
						<div class="row pt-1">
							<div class="col-lg-4">
								<label>Términos y Condiciones a Utilizar</label>
							</div>
							<div class="col-lg-2">
								<div class="form-check form-check-inline">
									<label class="check_box m-0 pl-4">
                        				<input checked id="A" v-model="Propuesta.TipoTerminos" value="A" type="radio" class="form-check-input">
                        				<span class="checkmark" style="border:2px solid #bababa"></span>
                        			</label>
									<span class="bold pb-2">A</span>
								</div>
							</div>
							<div class="col-lg-2">
								<div class="form-check form-check-inline">
									<label class="check_box m-0 pl-4">
                        				<input checked id="B" v-model="Propuesta.TipoTerminos" value="B" type="radio" class="form-check-input">
                        				<span class="checkmark" style="border:2px solid #bababa"></span>
                        			</label>
									<span class="bold pb-2">B</span>
								</div>
							</div>
							<div class="col-lg-2">
								<div class="form-check form-check-inline">
									<label class="check_box m-0 pl-4">
                        				<input checked id="C" v-model="Propuesta.TipoTerminos" value="C" type="radio" class="form-check-input">
                        				<span class="checkmark" style="border:2px solid #bababa"></span>
                        			</label>
									<span class="bold pb-2">C</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="pOrigen!='cotizacion'" class="col-lg-12 mb-3">
						<label for="">Observaciones</label>
						<textarea cols="30" rows="5" v-model="Propuesta.Observaciones" class="form-control"></textarea>
					</div>
                </div>
				<div class="row" v-if="pOrigen=='cotizacion' || Propuesta.IdVendedor!=0">
					<hr/>
					<div class="col-lg-12">
						<h5>Datos del Vendedor</h5>
						<div class="row">
							<div class="col-lg-4">
								<label for="">Nombre</label>
								<input type="text" v-model="Vendedor.Nombre" disabled class="form-control"/>
							</div>
							<div class="col-lg-4">
								<label for="">Teléfono</label>
								<input type="text" v-model="Vendedor.Telefono" disabled class="form-control"/>
							</div>
							<div class="col-lg-4">
								<label for="">Email</label>
								<input type="text" v-model="Vendedor.Correo" disabled class="form-control"/>
							</div>
						</div>
					</div>
				</div>
            </template>
			<!-- ===================================EL TEMA DE LAS PERSTANIAS INICIA AQUI================================== -->
			<template slot="BodyFormLoad" v-else>
				<div class="row">
					<div class="col-lg-12">
						<nav>
							<div class="nav nav-tabs nav-tabs-table" id="nav-tab" role="tablist">
								<a @click="SetSegundaPestania(false)" class="nav-item nav-link active" style="" id="general-tab" data-toggle="tab" href="#nav-general" role="tab" aria-controls="nav-general" aria-selected="true">Datos Generales</a>
								<a @click="SetSegundaPestania(true)" class="nav-item nav-link" style="" id="desarrollo-tab" data-toggle="tab" href="#nav-desarrollo" role="tab" aria-controls="nav-desarrollo" aria-selected="true">Desarrollo</a>
							</div>
						</nav>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-12">
						<div class="tab-content tab-content-table">
							<div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="general-tab">
								<div class="row">
									<div class="col-lg-6">
										<label for="">Atención A *</label>
										<input type="text" v-model="Propuesta.AtencionA" placeholder="Atención A" class="form-control">
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.AtencionA" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
									</div>
									<div class="col-lg-6">
										<label for="">Correo Electrónico</label>
										<vue-tags-input v-model="Email" :tags="Para" 
										@tags-changed="newTags => Para = newTags" 
										placeholder="Para"/>
									</div>
								</div>
                				<div class="row">
                				    <div class="col-lg-4">
                				        <label for="">Propiedad *</label>
                				        <input type="text" disabled v-model="Propuesta.Propiedad" placeholder="Propiedad" class="form-control">
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Propiedad" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
                				    <div class="col-lg-2">
                				        <label for="">Numero *</label>
                				        <input :disabled="Folio!=''" type="text" v-model="Propuesta.Numero" placeholder="Numero" class="form-control">
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Numero" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
									<div class="col-lg-3">
                				        <label for="">Tipo *</label>
                				        <!-- <input type="text" v-model="Propuesta.Tipo" placeholder="Tipo" class="form-control"> -->
										<select @change="GetTipoSer" v-model="Propuesta.Tipo" class="form-control">
											<option value="">Seleccione un Tipo</option>
											<option value="1">Mantenimiento</option>
											<option value="2">Servicio</option>
											<option value="3">Proyecto</option>
										</select>
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
									<div class="col-lg-3">
                				        <label for="">Sub Tipo *</label>
                				        <!-- <input type="text" v-model="Propuesta.Tipo" placeholder="Tipo" class="form-control"> -->
										<select v-model="Propuesta.IdTipoSer" class="form-control">
											<option value="">Seleccione un Sub Tipo</option>
											<option v-for="(item,index) in ListaTipoSer" :value="item.IdTipoSer" :key="index">{{item.Concepto}}</option>
										</select>
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdTipoSer" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
                				</div>
                				<div class="row">
                				    <div class="col-lg-4">
                				        <label for="">Nombre de la Propuesta *</label>
                				        <input type="text" v-model="Propuesta.NombrePropuesta" placeholder="Nombre de la Propuesta" class="form-control">
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NombrePropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
									<div class="col-lg-3">
                				        <label for="">Valor *</label>
                				        <vue-numeric
                				            class="form-control "
                				            currency="$"
                				            separator=","
                				            placeholder="$0"
                				            :precision="0"
                				            v-model="Propuesta.Valor"
                				        ></vue-numeric>
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Valor" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
									<div class="col-lg-2 pr-1">
                				        <label for="">Fecha *</label>
                				        <v-date-picker v-model="Propuesta.Fecha" :mode="typeCalendar"
                				            :popover="{
                				                placement: 'bottom',
                				                visibility: 'click'
                				            }"
                				            :input-props="{
                				                class: 'form-control cal-black',
                				                style: 'cursor:pointer;'
                				            }"
                				            :locale="'es-MX'"
                				        />
                				    </div>
									<div class="col-lg-3">
                				        <label for="">Vigencia *</label>
										<select v-model="Propuesta.Vigencia" class="form-control">
											<option value="">Seleccione una Opción</option>
											<option value="5">5 Días</option>
											<option value="10">10 Días</option>
											<option value="15">15 Días</option>
											<option value="20">20 Días</option>
											<option value="30">30 Días</option>
											<option value="60">60 Días</option>
										</select>
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Vigencia" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
                				</div>
                				<div class="row mb-3">
									<div v-show="pOrigen!='cotizacion' || Propuesta.IdCotizacionServicio>0" class="col-lg-3 pr-4">
                				        <label for="">Estatus *</label>
										<select :disabled="pOrigen=='ventas' || (pOrigen!='cotizacion' && RolUsuario!='admin' && Propuesta.IdPropuesta>0) || PropuestaGanada" v-model="Propuesta.Estatus" class="form-control">
											<option value="">Selecciones un Estatus</option>
											<option v-show="BndActiva===true" value="Activa">Activa</option>
											<option v-show="BndGanada===true" value="Ganada">Ganada</option>
											<option value="Perdida">Perdida</option>
											<option v-show="BndReemplazada===true" value="Reemplazada">Reemplazada</option>
										</select>
                				        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Estatus" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                				    </div>
									<div class="col-lg-3 mt-4">
										<div class="form-check form-check-inline">
											<label class="check_box m-0 pl-4">
                				    			<input checked id="critica" v-model="Propuesta.Critica" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<span class="bold pb-2">Propuesta Crítica</span>
										</div>
									</div>
									<div class="col-lg-3 mt-4">
										<div class="form-check form-check-inline">
											<label class="check_box m-0 pl-4">
                				    			<input checked id="carta" v-model="Propuesta.CartaPresentacion" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<span class="bold pb-2">Carta Presentación</span>
										</div>
									</div>
									<div class="col-lg-3 mt-4">
										<div class="form-check form-check-inline">
											<label class="check_box m-0 pl-4">
                				    			<input id="oficinas" v-model="Propuesta.NuestrasOficinas" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<span class="bold pb-2">Nuestras Oficinas</span>
										</div>
									</div>
									<div class="col-lg-3 mt-4">
										<div class="form-check form-check-inline">
											<label class="check_box m-0 pl-4">
                				    			<input id="Desglose" disabled v-model="Propuesta.VerDesglose" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa;background-color: grey;"></span>
                				    		</label>
											<span class="bold pb-2">Desglose</span>
										</div>
									</div>
                				</div>
                				<div class="row">
									<div v-if="pOrigen!='cotizacion'" class="col-lg-6 mb-3">
										<label for="">Vendedor</label>
										<select @change="RellenaVendedor" class="form-control" v-model="Propuesta.IdVendedor" :disabled="Propuesta.IdCotizacionServicio!=''">
											<option value="0">- Vendedor -</option>
											<option v-for="(item,index) in ListaVendedor" :key="index" :value="item.IdVendedor">{{item.Nombre}}</option>
										</select>
									</div>
                				    <div v-if="pOrigen!='cotizacion'" class="col-lg-6 mb-3">
                				        <label for="">Archivo</label>
                				        <div class="custom-file-input-image">
                				            <input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                				            <input type="text" v-model="Archivo" class="form-control">
                				            <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                				        </div>
                				    </div>
									<div v-if="pOrigen=='cotizacion' || Propuesta.IdCotizacionServicio!=''" class="col-lg-12">
										<div class="row pt-1">
											<div class="col-lg-4">
												<label>Términos y Condiciones a Utilizar</label>
											</div>
											<div class="col-lg-2">
												<div class="form-check form-check-inline">
													<label class="check_box m-0 pl-4">
                				        				<input checked id="A" v-model="Propuesta.TipoTerminos" value="A" type="radio" class="form-check-input">
                				        				<span class="checkmark" style="border:2px solid #bababa"></span>
                				        			</label>
													<span class="bold pb-2">A</span>
												</div>
											</div>
											<div class="col-lg-2">
												<div class="form-check form-check-inline">
													<label class="check_box m-0 pl-4">
                				        				<input checked id="B" v-model="Propuesta.TipoTerminos" value="B" type="radio" class="form-check-input">
                				        				<span class="checkmark" style="border:2px solid #bababa"></span>
                				        			</label>
													<span class="bold pb-2">B</span>
												</div>
											</div>
											<div class="col-lg-2">
												<div class="form-check form-check-inline">
													<label class="check_box m-0 pl-4">
                				        				<input checked id="C" v-model="Propuesta.TipoTerminos" value="C" type="radio" class="form-check-input">
                				        				<span class="checkmark" style="border:2px solid #bababa"></span>
                				        			</label>
													<span class="bold pb-2">C</span>
												</div>
											</div>
										</div>
									</div>
									<div v-if="pOrigen!='cotizacion'" class="col-lg-12 mb-3">
										<label for="">Observaciones</label>
										<textarea cols="30" rows="5" v-model="Propuesta.Observaciones" class="form-control"></textarea>
									</div>
                				</div>
								<div class="row" v-if="pOrigen=='cotizacion' || Propuesta.IdVendedor!=0">
									<hr/>
									<div class="col-lg-12">
										<h5>Datos del Vendedor</h5>
										<div class="row">
											<div class="col-lg-4">
												<label for="">Nombre</label>
												<input type="text" v-model="Vendedor.Nombre" disabled class="form-control"/>
											</div>
											<div class="col-lg-4">
												<label for="">Teléfono</label>
												<input type="text" v-model="Vendedor.Telefono" disabled class="form-control"/>
											</div>
											<div class="col-lg-4">
												<label for="">Email</label>
												<input type="text" v-model="Vendedor.Correo" disabled class="form-control"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-pane fade" id="nav-desarrollo" role="tabpanel" aria-labelledby="desarrollo-tab">
								<div class="row">
									<div class="col-lg-12">
										<div class="form-check form-check-inline">
											<span class="bold pb-2 mr-2">Problema Detectado</span>
											<label class="check_box m-0 pl-4">
                				    			<input id="problema" v-model="Propuesta.VerProblema" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<small class="mr-2">(max. 950 caracteres)</small>
										</div>
										<div class="form-group">
											<textarea @input="ContarCaracteresProblema" ref="problema" maxlength="950" cols="30" rows="5" v-model="Propuesta.ProblemaDetectado" class="form-control"></textarea>
										</div>
										<div class="form-group d-flex justify-content-end">
											<span class="contadorcaracteres">{{CaracteresProblema}}</span>
											<span class="contadorcaracteres">{{' /' + 950}}</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-12">
										<div class="form-check form-check-inline">
											<span class="bold pb-2 mr-2">Beneficios Esperados</span>
											<label class="check_box m-0 pl-4">
                				    			<input id="beneficios" v-model="Propuesta.VerBeneficios" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<small class="mr-2">(max. 930 caracteres)</small>
										</div>
										<div class="form-group">
											<textarea @input="ContarCaracteresBeneficios" maxlength="930" ref="beneficios" cols="30" rows="5" v-model="Propuesta.BeneficiosEsperados" class="form-control"></textarea>
										</div>
										<div class="form-group d-flex justify-content-end">
											<span class="contadorcaracteres">{{CaracteresBeneficios}}</span>
											<span class="contadorcaracteres">{{' /' + 930}}</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-12">
										<div class="form-check form-check-inline">
											<span class="bold pb-2 mr-2">Riesgo de No Hacer Nada</span>
											<label class="check_box m-0 pl-4">
                				    			<input id="riesgo" v-model="Propuesta.VerRiesgo" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<small class="mr-2">(max. 800 caracteres)</small>
										</div>
										<div class="form-group">
											<textarea @input="ContarCaracteresRiesgos" ref="riesgos" maxlength="800" cols="30" rows="5" v-model="Propuesta.Riesgo" class="form-control"></textarea>
										</div>
										<div class="form-group d-flex justify-content-end">
											<span class="contadorcaracteres">{{CaracteresRiesgos}}</span>
											<span class="contadorcaracteres">{{' /' + 800}}</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-12 mt-1">
										<!-- <div class="form-check form-check-inline">
											<span class="bold pb-2 mr-2">Programa de Trabajo *</span>
											<label class="check_box m-0 pl-4">
                				    			<input id="programa" v-model="Propuesta.VerPrograma" type="checkbox" class="form-check-input">
                				    			<span class="checkmark" style="border:2px solid #bababa"></span>
                				    		</label>
											<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.VerPrograma" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
										</div> -->
										<div class="form-group">
											<span class="bold">Programa de Trabajo *</span> <small class="mr-2">(max. 930 caracteres)</small>
											<textarea @input="ContarCaracteresPrograma" ref="programa" maxlength="930" cols="30" rows="5" v-model="Propuesta.ProgramaTrabajo" class="form-control mt-2"></textarea>
											<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.ProgramaTrabajo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
										</div>
										<div class="form-group d-flex justify-content-end">
											<span class="contadorcaracteres">{{CaracteresPrograma}}</span>
											<span class="contadorcaracteres">{{' /' + 930}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="f1-buttons mt-4" v-show="pOrigen=='cotizacion' || Propuesta.IdCotizacionServicio>0">
					<button v-show="SegundaPestania===true" @click="AnteriorTab()" type="button" class="btn btn-01 mr-2">
						<!-- <i v-show="Disablebtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> -->
						<i class="fa fa-arrow-circle-left"></i>
						Anterior
					</button>
					<button v-show="SegundaPestania===false" @click="Guardar(1)" type="button" class="btn btn-01 mr-2">
						<!-- <i v-show="Disablebtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> -->
						Siguiente
						<i class="fa fa-arrow-circle-right"></i>
					</button>
					<button :disabled="Disablebtn" v-show="SegundaPestania===true" @click="Guardar(2)" type="button" class="btn btn-01 mr-2">
						<i v-show="Disablebtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
						<i class="fa fa-plus-circle"></i>
						Guardar
					</button>
				</div>
			</template>
        </CLoader>
    </div>
</template>

<script>
export default {
    name:"Form",
    props:["poBtnSave","pIdClienteS","pContacto","pOrigen","pVendedor"],
    data() {
        return {
			Email:'',
            Modal:true,
            FormName:'Propuestas',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            Propuesta:{
                IdPropuesta:0,
                IdCliente:null,
                IdClienteS:null,
                Propiedad:'',
                Ciudad:'',
                Numero:'',
                NombrePropuesta:'',
                NombreEquipo:'',
                Valor:'',
                Fecha:'',
                Vigencia:'',
                Urgencia:'',
                Archivo:'',
                Estatus:'',
				Tipo:'',
				IdCotizacionServicio:'',
				NombreArchivo:'',
				NombreArchivoFile:null,
				FechaReg:'',
				TipoTerminos:'',
				AtencionA:'',
				Email:'',
				IdVendedor:0,
				IdTipoSer:'',
				Observaciones:'',
				CartaPresentacion:false,
				Critica:false,
				NuestrasOficinas:false,
				VerDesglose:true,
				VerProblema:false,
				ProblemaDetectado:'',
				VerBeneficios:false,
				BeneficiosEsperados:'',
				VerRiesgo:false,
				Riesgo:'',
				VerPrograma:true,
				ProgramaTrabajo:'',
				IdEquipo:null
            },
			Folio:'',
			Para:[],
			FechaActualizacion:'2025-04-30',
            Archivo:'Elegir Archivo (0.5MB)',
            errorvalidacion:[],
			Vendedor:{},
			ListaTipoSer:[],
			ListaVendedor:[],
			RolUsuario:'',
			PropuestaGanada:false,
			SegundaPestania:false,
			Disablebtn:false,
			CaracteresProblema:0,
			CaracteresBeneficios:0,
			CaracteresRiesgos:0,
			CaracteresPrograma:0,
			Equipos:[],
			EquiposCopia:[],
			BndActiva:true,
			BndGanada:false,
			BndReemplazada:false,
			ListaClientes:[],
			ListaPropiedades:[],
			Contador:0
        }
    },
    methods: {
		async GetListaClientes(){
            await this.$http.get("clientes/get"
			).then((res)=>{
				this.ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				});
			});
        },
		async GetListaPropiedades(){
			if (this.Contador>0 || this.Propuesta.IdPropuesta==0) {
				this.Propuesta.IdClienteS=null;
			}
			this.ListaPropiedades=[];
			this.$http.get("clientesucursal/get",{
				params:{
					Todos:true,
					RegEstatus:'A',
					IdCliente:this.Propuesta.IdCliente
				}
			}
			).then((res)=>{
				this.ListaPropiedades=res.data.data.sucursal.map(function(obj){
					return {id:obj.IdClienteS,label:obj.Nombre}
				});
				this.Contador=1;
			})
		},
		ContarCaracteresProblema(){
			this.CaracteresProblema=this.$refs.problema.value.length;
		},
		ContarCaracteresBeneficios(){
			this.CaracteresBeneficios=this.$refs.beneficios.value.length;
		},
		ContarCaracteresRiesgos(){
			this.CaracteresRiesgos=this.$refs.riesgos.value.length;
		},
		ContarCaracteresPrograma(){
			this.CaracteresPrograma=this.$refs.programa.value.length;
		},
		SetSegundaPestania(Valor){
			this.SegundaPestania=Valor;
		},
		AnteriorTab(){
			$('#general-tab').tab('show');
			this.SetSegundaPestania(false);
		},
        Guardar(Camino=1){
			if (this.pOrigen=="cotizacion") {
				if (Camino==1) {
					$('#desarrollo-tab').tab('show');
					this.SetSegundaPestania(true);
				}
				else{
					this.poBtnSave.disableBtn=true;
					this.Disablebtn=true;
					this.poBtnSave.toast=0;
					this.errorvalidacion={};
					if (this.Propuesta.AtencionA=='') {
						this.errorvalidacion.AtencionA='error';
					}
					if (this.Propuesta.Numero=='') {
						this.errorvalidacion.Numero='error';
					}
					if (this.Propuesta.NombrePropuesta=='') {
						this.errorvalidacion.NombrePropuesta='error';
					}
					if (this.Propuesta.Valor=='') {
						this.errorvalidacion.Valor='0';
					}
					if (this.Propuesta.Vigencia=='') {
						this.errorvalidacion.Vigencia='error';
					}
					if (this.Propuesta.Estatus=='') {
						this.errorvalidacion.Estatus='error';
					}
					if (this.Propuesta.Tipo=='') {
						this.errorvalidacion.Tipo='error';
					}
					if (this.Propuesta.VerPrograma===false) {
						this.errorvalidacion.VerPrograma='error';
					}
					if (this.Propuesta.ProgramaTrabajo=='') {
						this.errorvalidacion.ProgramaTrabajo='error';
					}
					if (Object.keys(this.errorvalidacion).length===0 && this.errorvalidacion.constructor === Object) {
						this.Propuesta.Email=this.Para;
						this.bus.$emit('SaveCotizacion',this.Propuesta);	
					}
					else{
						this.poBtnSave.disableBtn=false;
            		    this.poBtnSave.toast=2;
						this.$toast.warning('Complete los campos');
						this.Disablebtn=false;
						return false;
					}
				}
			}
			else{
				if (this.Propuesta.IdCotizacionServicio>0) {
					if (Camino==1) {
						$('#desarrollo-tab').tab('show');
						this.SetSegundaPestania(true);
					}
					else{
						this.errorvalidacion=[];
						if (this.Propuesta.VerPrograma===false) {
							this.errorvalidacion.VerPrograma='error';
						}
						if (this.Propuesta.ProgramaTrabajo=='') {
							this.errorvalidacion.ProgramaTrabajo='error';
						}
						if (Object.keys(this.errorvalidacion).length!==0) {
							this.poBtnSave.disableBtn=false;
            		    	this.poBtnSave.toast=2;
							this.$toast.warning('Complete los campos');
							this.Disablebtn=false;
							return false;
						}
						this.Disablebtn=true;
						let Fecha='';
            			if (this.Propuesta.Fecha!='' && this.Propuesta.Fecha!=undefined) {
            			    let day=this.Propuesta.Fecha.getDate();
            			    let month=this.Propuesta.Fecha.getMonth()+1;
            			    let year=this.Propuesta.Fecha.getFullYear();
            			    Fecha=year+'-'+month+'-'+day;   
            			}
            			let file = this.$refs.file.files[0];
            			let formData=new FormData();
            			formData.set('IdPropuesta',this.Propuesta.IdPropuesta);
            			formData.set('IdCliente',this.Propuesta.IdCliente);
            			formData.set('IdClienteS',this.Propuesta.IdClienteS);
            			formData.set('Ciudad',this.Propuesta.Ciudad);
            			formData.set('Numero',this.Propuesta.Numero);
            			formData.set('NombrePropuesta',this.Propuesta.NombrePropuesta);
            			formData.set('NombreEquipo',this.Propuesta.NombreEquipo);
            			formData.set('Valor',this.Propuesta.Valor);
            			formData.set('Fecha',Fecha);
            			formData.set('Vigencia',this.Propuesta.Vigencia);
						formData.set('IdVendedor',this.Propuesta.IdVendedor);
            			formData.set('Urgencia',this.Propuesta.Urgencia);
            			formData.set('NombreArchivo',this.Propuesta.Archivo);
            			formData.set('Estatus',this.Propuesta.Estatus);
						formData.set('Observaciones',this.Propuesta.Observaciones);
						formData.set('Tipo',this.Propuesta.Tipo);
						formData.set('AtencionA',this.Propuesta.AtencionA);
						formData.set('TipoTerminos',this.Propuesta.TipoTerminos);
						formData.set('IdTipoSer',this.Propuesta.IdTipoSer);
						formData.set('IdVendedor',this.Propuesta.IdVendedor);
						formData.set('VerDesglose',this.Propuesta.VerDesglose===true ? 1 : 0);
						formData.set('NuestrasOficinas',this.Propuesta.NuestrasOficinas===true ? 1 : 0);
						formData.set('CartaPresentacion',this.Propuesta.CartaPresentacion===true ? 1 : 0);
						formData.set('Critica',this.Propuesta.Critica===true ? 1 : 0);
						formData.set('VerProblema',this.Propuesta.VerProblema===true ? 1 : 0);
						formData.set('VerBeneficios',this.Propuesta.VerBeneficios===true ? 1 : 0);
						formData.set('VerRiesgo',this.Propuesta.VerRiesgo===true ? 1 : 0);
						formData.set('VerPrograma',this.Propuesta.VerPrograma===true ? 1 : 0);
						formData.set('ProblemaDetectado',this.Propuesta.ProblemaDetectado);
						formData.set('BeneficiosEsperados',this.Propuesta.BeneficiosEsperados);
						formData.set('Riesgo',this.Propuesta.Riesgo);
						formData.set('ProgramaTrabajo',this.Propuesta.ProgramaTrabajo);
						formData.set('Email',JSON.stringify(this.Para));
						formData.set('IdCotizacionServicio',this.Propuesta.IdCotizacionServicio);
            			formData.append('NombreArchivoFile',file);
            			this.poBtnSave.toast=0;
            			this.poBtnSave.disableBtn=true;
            			this.$http.post('propuestas/post',formData,{
            			    headers:{
            			        'Content-Type':'multipart/form-data'
            			    }
            			}).then((res)=>{
            			    this.poBtnSave.disableBtn=false; 
            			    this.$toast.success('Información guardada');
            			    $("#Propuesta").modal("hide");
							if (this.pOrigen=='modulo') {
								this.bus.$emit('List');	
							}
							if (this.pOrigen=='ventas') {
								this.bus.$emit('AsignarPropuesta',res.data.data);
							}
            			}).catch((err)=>{
            			    this.errorvalidacion=err.response.data.message.errores;
            			    this.poBtnSave.disableBtn=false;
            			    this.poBtnSave.toast=2;
            			})
					}	
				}
				else{
					this.Disablebtn=true;
					let Fecha='';
            		if (this.Propuesta.Fecha!='' && this.Propuesta.Fecha!=undefined) {
            		    let day=this.Propuesta.Fecha.getDate();
            		    let month=this.Propuesta.Fecha.getMonth()+1;
            		    let year=this.Propuesta.Fecha.getFullYear();
            		    Fecha=year+'-'+month+'-'+day;   
            		}
            		let file = this.$refs.file.files[0];
            		let formData=new FormData();
            		formData.set('IdPropuesta',this.Propuesta.IdPropuesta);
            		formData.set('IdCliente',this.Propuesta.IdCliente);
            		formData.set('IdClienteS',this.Propuesta.IdClienteS);
            		formData.set('Ciudad',this.Propuesta.Ciudad);
            		formData.set('Numero',this.Propuesta.Numero);
            		formData.set('NombrePropuesta',this.Propuesta.NombrePropuesta);
            		formData.set('NombreEquipo',this.Propuesta.NombreEquipo);
            		formData.set('Valor',this.Propuesta.Valor);
            		formData.set('Fecha',Fecha);
            		formData.set('Vigencia',this.Propuesta.Vigencia);
					formData.set('IdVendedor',this.Propuesta.IdVendedor);
            		formData.set('Urgencia',this.Propuesta.Urgencia);
            		formData.set('NombreArchivo',this.Propuesta.Archivo);
            		formData.set('Estatus',this.Propuesta.Estatus);
					formData.set('Observaciones',this.Propuesta.Observaciones);
					formData.set('Tipo',this.Propuesta.Tipo);
					formData.set('AtencionA',this.Propuesta.AtencionA);
					formData.set('TipoTerminos',this.Propuesta.TipoTerminos);
					formData.set('IdTipoSer',this.Propuesta.IdTipoSer);
					formData.set('IdVendedor',this.Propuesta.IdVendedor);
					formData.set('VerDesglose',this.Propuesta.VerDesglose===true ? 1 : 0);
					formData.set('NuestrasOficinas',this.Propuesta.NuestrasOficinas===true ? 1 : 0);
					formData.set('CartaPresentacion',this.Propuesta.CartaPresentacion===true ? 1 : 0);
					formData.set('Critica',this.Propuesta.Critica===true ? 1 : 0);
					formData.set('VerProblema',this.Propuesta.VerProblema===true ? 1 : 0);
					formData.set('VerBeneficios',this.Propuesta.VerBeneficios===true ? 1 : 0);
					formData.set('VerRiesgo',this.Propuesta.VerRiesgo===true ? 1 : 0);
					formData.set('VerPrograma',this.Propuesta.VerPrograma===true ? 1 : 0);
					formData.set('ProblemaDetectado',this.Propuesta.ProblemaDetectado);
					formData.set('BeneficiosEsperados',this.Propuesta.BeneficiosEsperados);
					formData.set('Riesgo',this.Propuesta.Riesgo);
					formData.set('ProgramaTrabajo',this.Propuesta.ProgramaTrabajo);
					formData.set('Email',JSON.stringify(this.Para));
					formData.set('IdCotizacionServicio',this.Propuesta.IdCotizacionServicio);
					formData.set('IdEquipo',this.Propuesta.IdEquipo==null ? 0 : this.Propuesta.IdEquipo);
            		formData.append('NombreArchivoFile',file);
            		this.poBtnSave.toast=0;
            		this.poBtnSave.disableBtn=true;
            		this.$http.post('propuestas/post',formData,{
            		    headers:{
            		        'Content-Type':'multipart/form-data'
            		    }
            		}).then((res)=>{
            		    this.poBtnSave.disableBtn=false; 
            		    this.poBtnSave.toast=1;
            		    $("#Propuesta").modal("hide");
						if (this.pOrigen=='modulo') {
							this.bus.$emit('List');	
						}
						if (this.pOrigen=='ventas') {
							this.bus.$emit('AsignarPropuesta',res.data.data);
						}
            		}).catch((err)=>{
            		    this.errorvalidacion=err.response.data.message.errores;
            		    this.poBtnSave.disableBtn=false;
            		    this.poBtnSave.toast=2;
            		})
				}
			}
        },
        Limpiar(){
			this.Disablebtn=false;
			this.SegundaPestania=false;
			if (this.pOrigen!='cotizacion') {
				const  input  = this.$refs.file;
            	input .type = 'text'
            	input .type = 'file';	
			}
            this.Propuesta={
                IdPropuesta:0,
                IdCliente:null,
                IdClienteS:null,
                Propiedad:'',
                Ciudad:'',
                Numero:'',
                NombrePropuesta:'',
                NombreEquipo:'',
                Valor:'',
                Fecha:new Date(),
                Vigencia:'',
                Urgencia:'',
                Archivo:'Elegir Archivo (0.5MB)',
                Estatus:'Activa',
				Tipo:'',
				IdCotizacionServicio:'',
				NombreArchivo:'',
				FechaReg:'',
				NombreArchivoFile:null,
				TipoTerminos:'',
				AtencionA:'',
				Email:[],
				IdVendedor:0,
				IdTipoSer:'',
				Observaciones:'',
				CartaPresentacion:false,
				Critica:false,
				NuestrasOficinas:false,
				VerDesglose:true,
				VerProblema:false,
				ProblemaDetectado:'',
				VerBeneficios:false,
				BeneficiosEsperados:'',
				VerRiesgo:false,
				Riesgo:'',
				VerPrograma:true,
				ProgramaTrabajo:'',
				IdEquipo:null
            },
			this.ListaTipoSer=[];
			this.Folio=''
			this.Para=[],
			this.Equipos=[];
			this.EquiposCopia=[];
			this.Vendedor={Nombre:'',Telefono:'',Correo:''}
            // if (localStorage.getItem("fechacalendario")) {
			// 	let NuevaFecha = localStorage.getItem("fechacalendario");
			// 	let formatedDate = NuevaFecha.replace(/-/g, "\/");
			// 	this.Propuesta.Fecha = new Date(formatedDate);
			// }
            this.Archivo='Elegir Archivo (0.5MB)';
			this.Email='';
			this.PropuestaGanada=false;
			this.CaracteresProblema=0;
			this.CaracteresBeneficios=0;
			this.CaracteresRiesgos=0;
			this.CaracteresPrograma=0;
			this.errorvalidacion=[];
			this.Contador=0;
        },
        Recuperar(){
			this.BndActiva=false;
			this.BndGanada=false;
			this.BndReemplazada=false;
            this.$http.get('propuestas/recovery',{
                params:{
                    IdPropuesta:this.Propuesta.IdPropuesta
                }
            }).then((res)=>{
                const objres=res.data.data.propuesta;
                this.Propuesta.IdPropuesta=objres.IdPropuesta;
                this.Propuesta.IdCliente=objres.IdCliente;
                this.Propuesta.IdClienteS=objres.IdClienteS;
                this.Propuesta.Propiedad=objres.Propiedad;
                this.Propuesta.Ciudad=objres.Ciudad;
                this.Propuesta.Numero=objres.Numero;
                this.Propuesta.NombrePropuesta=objres.NombrePropuesta;
                this.Propuesta.NombreEquipo=objres.NombreEquipo;
                this.Propuesta.Valor=objres.Valor;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.Propuesta.Fecha=new Date(formatedDate);
                this.Propuesta.Vigencia=objres.Vigencia;
                this.Propuesta.Urgencia=objres.Urgencia.toLowerCase();
                this.Propuesta.Archivo=objres.Archivo;
                this.Propuesta.Estatus=objres.Estatus;
				this.Propuesta.Tipo=objres.Tipo;
				this.Propuesta.Observaciones=objres.DescripcionPropuesta;
				this.Propuesta.FechaReg=objres.FechaReg;
				this.Propuesta.TipoTerminos=objres.TipoTerminos;
				this.Propuesta.IdCotizacionServicio=objres.IdCotizacionServicio;
				this.Propuesta.AtencionA=objres.AtencionA;
				this.Propuesta.IdTipoSer=objres.IdTipoSer;
				this.Propuesta.Email=objres.Email;
				this.Propuesta.IdVendedor=objres.IdVendedor;
				this.Propuesta.VerDesglose=objres.VerDesglose == 0 ? false : true;
				this.Propuesta.CartaPresentacion=objres.CartaPresentacion == 0 ? false : true;
				this.Propuesta.Critica=objres.Critica == 0 ? false : true;
				this.Propuesta.NuestrasOficinas=objres.NuestrasOficinas == 0 ? false : true;
				this.Propuesta.VerProblema=objres.VerProblema == 0 ? false : true;
				this.Propuesta.VerBeneficios=objres.VerBeneficios == 0 ? false : true;
				this.Propuesta.VerRiesgo=objres.VerRiesgo == 0 ? false : true;
				this.Propuesta.VerPrograma=objres.VerPrograma == 0 ? false : true;
				this.Propuesta.ProblemaDetectado=objres.ProblemaDetectado;
				this.Propuesta.BeneficiosEsperados=objres.BeneficiosEsperados;
				this.Propuesta.Riesgo=objres.Riesgo;
				this.Propuesta.ProgramaTrabajo=objres.ProgramaTrabajo;
				this.Propuesta.IdEquipo=objres.IdEquipo==0 ? null : objres.IdEquipo;

				if (this.Propuesta.Email!='') {
					this.Para=[];
					this.Para.push({ "text": this.Propuesta.Email,"tiClasses": ["ti-valid"]});
				}
				if (res.data.data.vendedor!='') {
					this.Vendedor=res.data.data.vendedor;
				}
				switch (this.Propuesta.Estatus) {
					case "Activa":
						this.BndActiva=true;
						break;
					case "Ganada":
						this.BndGanada=true;
						break;
					case "Reemplazada":
						this.BndReemplazada=true;
						break;
					default:
						break;
				}
				// this.Propuesta.Email=this.Propuesta.Email.slice(-1, 0)
				// console.log(this.Propuesta.IdCotizacionServicio);
                this.Archivo=objres.Archivo==''? 'Elegir Archivo (3MB)' : objres.Archivo;
				if (this.Propuesta.Estatus=='Ganada') {
					this.PropuestaGanada=true;
				}
				this.bus.$emit('EnableBtnPropuesta',this.Propuesta.IdPropuesta,this.Propuesta.IdCotizacionServicio);
				this.GetTipoSer();
            }).finally(()=>{
				if (this.Propuesta.IdCotizacionServicio>0) {
					this.CaracteresProblema=this.$refs.problema.value.length;
					this.CaracteresBeneficios=this.$refs.beneficios.value.length;
					this.CaracteresRiesgos=this.$refs.riesgos.value.length;
					this.CaracteresPrograma=this.$refs.programa.value.length;	
				}
				if (this.Propuesta.FechaReg>=this.FechaActualizacion) {
					this.GetFolio();
				}
				else{
					this.ConfigLoad.ShowLoader=false;
				}
				// this.ConfigLoad.ShowLoader=false;
            })
        },
        SubirArchivo(){
            const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
        },
		async GetTipoSer(){
			await this.$http.get('tiposervicio/get',{
				params:{
					RegEstatus:'A',
					IdConfigS:this.Propuesta.Tipo,
					// IdTipoServ:this.contract.IdTipoServ,
					Entrada:''
				}
			}).then( (res) => {
				this.ListaTipoSer=res.data.data.tiposervicio;
			});
		},
		GetFolio(){
			this.$http.get('folioexist/get',{
				params:{
					Tipo:'PROPUESTA'
				}
			}).then((res)=>{
				if (this.Propuesta.IdPropuesta==0) {
					this.Folio=res.data.data.folio.Serie+(parseInt(res.data.data.folio.Numero)+1);	
					this.Propuesta.Numero=this.Folio;
				}
				else{
					// console.log(this.Propuesta.Numero.includes(res.data.data.folio));
					if (res.data.status && this.Propuesta.Numero.includes(res.data.data.folio.Serie)) {
						this.Folio='algo'
					}
				}
				// this.Folio=res.data.data.folio.Serie+(parseInt(res.data.data.folio.Numero)+1);	
				// this.Propuesta.Numero=this.Folio;
				this.ConfigLoad.ShowLoader=false;
			}).catch((err)=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		async GetListaVendedor(){
			await this.$http.get('vendedorcotizacion/get',{
				params:{

				}
			}).then((res)=>{
				this.ListaVendedor=res.data.data.todos;
			})
		},
		RellenaVendedor(){
			let index=this.ListaVendedor.findIndex((value) => value.IdVendedor==this.Propuesta.IdVendedor)
			this.Vendedor=this.ListaVendedor[index];
		},
		async ListActivos(){
			await this.$http.get('equipos/get',{
				params:{
					Todos:true,
					IdClienteS:this.Propuesta.IdClienteS
				}
			}).then((res)=>{
				this.Equipos=res.data.data.equipos.map((Element) => {
					let Tag='';
					if (Element.CodigoActivo!=null) {
						Tag=Element.CodigoActivo+' - '+Element.Nequipo
					}
					else{
						Tag=Element.Nequipo
					}
					return{
						id:Element.IdEquipo,
						label:Tag
					}
				})
				this.EquiposCopia=res.data.data.equipos.map((Element) => {
					let Tag='';
					if (Element.CodigoActivo!=null) {
						Tag=Element.CodigoActivo+' - '+Element.Nequipo
					}
					else{
						Tag=Element.Nequipo
					}
					return{
						id:Element.IdEquipo,
						label:Tag
					}
				})
			})
		},
		BusquedaEquipo(){
			this.Equipos=this.$LikeSearch(val,this.EquiposCopia);
		}
    },
	beforeDestroy() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
	},
    created() {
        this.bus.$off("NewModal_"+this.EmitSeccion);
		let usuario=JSON.parse(this.RolUsuario=sessionStorage.getItem("user"));
		this.RolUsuario=usuario.Perfil.toLowerCase();
        
    },
	mounted() {
		this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,Propiedad,IdClienteS,Valor=0,NombrePropuesta='')=>{
			this.GetListaVendedor();
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (Propiedad!==undefined) {
                this.Propuesta.Propiedad=Propiedad.Nombre;
                this.Propuesta.IdCliente=Propiedad.IdCliente;
                this.Propuesta.Ciudad=Propiedad.Ciudad;
            }
            if (IdClienteS!==undefined) {
                this.Propuesta.IdClienteS=IdClienteS;
            }
			if (this.pVendedor!=undefined) {
				this.Propuesta.IdVendedor=this.pVendedor.IdVendedor;
				this.Vendedor=this.pVendedor;
			}
			if (Valor!=0) {
				this.Propuesta.Valor=Valor;
			}
			if (this.pOrigen=='cotizacion') {
				this.Propuesta.Estatus='Activa';
				this.Propuesta.NombrePropuesta=NombrePropuesta;
			}
			if (this.pOrigen=='ventas') {
				this.Propuesta.Estatus='Activa';
			}
			if (this.pOrigen!='cotizacion') {
				this.ListActivos();
			}
			if (this.pOrigen=='modulo') {
				this.GetListaClientes();
			}
            if (Id > 0) {
				this.Propuesta.IdPropuesta = Id;
				this.Recuperar();
			}
            else{
				this.bus.$emit('EnableBtnPropuesta',0,0);
				this.GetFolio();
                // this.ConfigLoad.ShowLoader=false;
            }
			// console.log(this.Propuesta.IdClienteS);
        });
	},
    computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
